export const LOADING_STATE = {
  GET: "GET",
  UPDATE: "UPDATE",
};
